import React from 'react';

const PageNotFound = () => {
  return (
    <div className="container-fluid not-found-wrapper d-flex flex-column justify-content-center align-items-center text-center">
      <div className="not-found-content">
        <h1 className="display-1 fw-bold text-danger">404</h1>
        <h2 className="mb-3">Oops! Page Not Found</h2>
        <p className="mb-4">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <a href="/" className="btn btn-primary px-4 py-2">Go to Homepage</a>
      </div>
    </div>
  );
};

export default PageNotFound;
